import BlockSelector from '@/components/block-selector/block-selector-component';
import Card from '@/components/card/card-component';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import QuoteCoverLetterForm from './quote-cover-letter-form';
import QuoteCustomerForm from './quote-customer-form';
import QuoteDetailsForm from './quote-details-form';
import QuoteMediaForm from './quote-media-form';
import QuotePriceForm from './quote-price-form';

const QuoteContainer = styled.div`
  display: flex;
  margin-top: 24px;
`;

/**
 * Page that shows the Quote Summary
 * @returns {JSX.Element} The rendered Quote Summary page component.
 */
const Quote = () => {
  const { state } = useLocation();
  const { tab } = state ?? { tab: 0 };

  const {
    formState: { errors },
  } = useFormContext();

  const priceTabErrors =
    (errors?.quote_modules_prices || errors?.quote)?.length > 0;
  const customerTabErrors =
    errors?.contact_person || errors?.customer?.length > 0;
  const detailsTabErrors = errors?.quote_modules_details?.length > 0;

  return (
    <QuoteContainer>
      <Card>
        <BlockSelector
          tabs={[
            {
              label: 'Price',
              content: <QuotePriceForm />,
              hasError: priceTabErrors,
            },
            {
              label: 'Customer',
              content: <QuoteCustomerForm />,
              hasError: customerTabErrors,
            },
            {
              label: 'Details',
              content: <QuoteDetailsForm />,
              hasError: detailsTabErrors,
            },
            { label: 'Media', content: <QuoteMediaForm /> },
            { label: 'Cover Letter', content: <QuoteCoverLetterForm /> },
          ]}
          selectedTab={tab}
        />
      </Card>
    </QuoteContainer>
  );
};

export default Quote;
